window.tbg = window.tbg || {};
window.tbg.apiV2 = (function (httpService, growlMessages) {
    'use strict';

    var GENERIC_FAILURE = 'The request could not be completed. Please try again or contact support.';

    if (!httpService || !growlMessages) {
        console.warn('Could not initialize apiV2 service. Dependencies not met.');
        return;
    }

    return function apiV2 (requestConfig) {
        return httpService(requestConfig)
            .then(handleApiMessage)
            .then(handleApiResponse)
            .catch(handleApiError);

        function handleApiMessage (response) {
            if (requestConfig.suppressDefaultMessages) {
                return response;
            }

            if (response.messages && response.messages.length) {
                response.messages.forEach(function (message) {
                    switch (message.type) {
                        case 'SUCCESS':
                            growlMessages.addInfoMessage(message.detail);
                            break;
                        case 'INFO':
                            growlMessages.addWarningMessage(message.detail);
                            break;
                        case 'WARNING':
                            growlMessages.addErrorMessage(message.detail);
                            break;
                    }
                });

                growlMessages.showQueue();
            }

            return response;
        }

        function handleApiResponse (response) {
            // When suppressDefaultMessages is set, preserve the full response wrapper
            // (including .messages and .content) so callers can handle both themselves.
            if (requestConfig.suppressDefaultMessages) {
                return response;
            }
            return response && response.content || response;
        }

        function defaultErrorHandler (response) {
            // TODO: Implement Input and Response error types...
            var errors = response && response.errors;
            if (errors && errors.length) {
                errors.forEach(function (e) {
                    growlMessages.addErrorMessage(e.detail);
                });
            } else {
                growlMessages.addErrorMessage(describeFailure(response));
            }

            growlMessages.showQueue();
            throw response;
        }

        // TTI-20868: httpService rejects with the raw jqXHR whenever the body isn't JSON, and an
        // empty errors array is still truthy - so this used to growl "[object Object]" or nothing.
        function describeFailure (response) {
            if (!response) {
                return GENERIC_FAILURE;
            }
            if (typeof response === 'string') {
                return response;
            }
            if (response.detail) {
                return response.detail;
            }
            if (response.message) {
                return response.message;
            }
            if (response.status) {
                return GENERIC_FAILURE + ' (HTTP ' + response.status + ')';
            }
            return GENERIC_FAILURE;
        }

        function handleApiError (response) {
            if (requestConfig.customErrorHandler) {
                return requestConfig.customErrorHandler(response);
            }

            var handlers = requestConfig.errorHandlers;
            if (handlers) {
                var status = response && response._httpStatus;
                var handler = (status && handlers[String(status)]) || handlers.default;
                if (handler) {
                    return handler(response);
                }
            }

            return defaultErrorHandler(response);
        }
    };

// TSP-670: publish the fallback instance. Left unpublished it became a second growl queue writing
// the same DOM as the page's own, and the two fought over it.
}(window.tbg.httpService, window.growlMessages = window.growlMessages || new GrowlMessages('userMessages', 'userMessageContent', 'growlMessages')));
